import { connect } from "react-redux";

import _ from "lodash";
import moment from "moment";

import React from "react";

import {
  Card,
  List,
  Modal,
  Header,
  Segment,
  Dimmer,
  Loader
} from "semantic-ui-react";

import { fetchDetailData } from "../Actions/DashboardActions";
const maxPreviewSize = 5;
const yes_no_map = {
  N: "No",
  Y: "Yes"
};

const aeListSectionFields = [
  {
    field: "OUTCOME",
    title: "AE Outcome",
    format: item => {
      return item;
    }
  },
  {
    field: "SERIOUSNESS",
    title: "AE Seriousness",
    format: item => {
      return item;
    }
  },
  {
    field: "CONGENITAL_ANOMALY",
    title: "Congenital Anomaly/Birth Defect?",
    format: item => {
      return yes_no_map[item];
    }
  },
  {
    field: "DEATH",
    title: "Death?",
    format: item => {
      return yes_no_map[item];
    }
  },
  {
    field: "DISABILITY",
    title: "Disability or Permanent Damage?",
    format: item => {
      return yes_no_map[item];
    }
  },
  {
    field: "HOSP_PROLONGED",
    title: "Hospitalization Prolonged?",
    format: item => {
      return yes_no_map[item];
    }
  },
  {
    field: "HOSP_REQUIRED",
    title: "Hospitalization New?",
    format: item => {
      return yes_no_map[item];
    }
  },
  {
    field: "LIFE_THREATENING",
    title: "Life Threatening?",
    format: item => {
      return yes_no_map[item];
    }
  },
  {
    field: "OTHER_MEDICALLY_IMP_COND",
    title: "Other Serious (Important Medical Events)",
    format: item => {
      return yes_no_map[item];
    }
  }
];

class AdverseEventDetailView extends React.Component {
  state = { modalOpen: false };

  handleOpen = () => {
    this.props.fetchDetailData();
    this.setState({ modalOpen: true });
  };

  handleClose = () => {
    this.setState({ modalOpen: false });
  };

  render() {
    const noAEsView = <div>No Adverse Events For This Case</div>;

    const aeCards = (
      <Card.Group>
        {_.map(this.props.adverse_event_detail, (ae, idx) => {
          const onset_date = moment(ae.ONSET_DATE).isValid()
            ? moment(ae.ONSET_DATE).format("DD/MMM/YYYY")
            : null;
          const cessation_date = moment(ae.CESSATION_DATE).isValid()
            ? moment(ae.CESSATION_DATE).format("DD/MMM/YYYY")
            : null;

          let duration_section;
          if (onset_date !== null || cessation_date !== null) {
            duration_section = (
              <Card.Meta>
                Onset: {onset_date === null ? "N/A" : onset_date} - Cessation:{" "}
                {cessation_date === null ? "N/A" : cessation_date}
              </Card.Meta>
            );
          }

          let aeListSection;
          const aeListSectionIsDefined = _.some(
            aeListSectionFields,
            section => {
              return (
                !_.isUndefined(ae[section.field]) && ae[section.field] !== null
              );
            }
          );
          if (aeListSectionIsDefined) {
            aeListSection = (
              <Card.Content>
                <List>
                  {_.reduce(
                    aeListSectionFields,
                    (result, section, idx) => {
                      if (
                        !_.isUndefined(ae[section.field]) &&
                        ae[section.field] !== null
                      ) {
                        result.push(
                          <List.Item key={idx}>
                            <List.Header>{section.title}</List.Header>
                            {section.format(ae[section.field])}
                          </List.Item>
                        );
                      }
                      return result;
                    },
                    []
                  )}
                </List>
              </Card.Content>
            );
          }

          return (
            <Card fluid key={idx}>
              <Card.Content>
                <Card.Header>
                  {_.startCase(_.toLower(ae.REPORTED_TERM))}
                </Card.Header>
                {duration_section}
              </Card.Content>
              {aeListSection}
            </Card>
          );
        })}
      </Card.Group>
    );

    // const modalTrigger = <Button circular onClick={this.handleOpen} icon='ambulance' color='teal' basic/>
    const aes = _.compact(_.map(this.props.aes, _.trim));
    const hasAEDataButMissingNames = (this.props.aes || []).length > 0 && (aes || []).length === 0;
    const modalTrigger = hasAEDataButMissingNames ? (
      <a>
        <div style={{ cursor: "pointer" }} onClick={this.handleOpen} title={'View Adverse Event Details'}>
          View Adverse Event Details
        </div>
      </a>
    ) : 
    (
      <a>
        <div style={{ cursor: "pointer" }} onClick={this.handleOpen} title={aes.join(', ')}>
          {(aes.slice(0, maxPreviewSize) || []).join(", ")}
          {aes.length > maxPreviewSize ? "..." : ""}
        </div>
      </a>
    );
    return (
      <Modal
        trigger={modalTrigger}
        open={this.state.modalOpen}
        onClose={this.handleClose}
        size="small"
      >
        <Header content="Adverse Events" />
        <Modal.Content scrolling>
          {this.props.fetching_adverse_event_detail && (
            <Segment style={{ height: "50vh" }}>
              <Dimmer active>
                <Loader>Loading</Loader>
              </Dimmer>
            </Segment>
          )}
          {!this.props.fetching_adverse_event_detail &&
            (this.props.adverse_event_detail.length > 0 ? aeCards : noAEsView)}
        </Modal.Content>
      </Modal>
    );
  }
}

//Binds the current Redux state to props that the sub component (DashboardView) uses
const mapStateToProps = (state, ownProps) => {
  return {
    adverse_event_detail: _.get(state, "dashboard.adverse_event_detail") || [],
    fetching_adverse_event_detail:
      _.get(state, "dashboard.fetching_adverse_event_detail") || false
  };
};

//map actions to properties to allow subcomponents tp update state
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDetailData: () => {
      dispatch(fetchDetailData(ownProps.record_id, "adverse_event_detail"));
    }
  };
};

//Boilerplate code to connect the subcomponent to the Redux state - automatically determines if the subcomponent should update when the state is updated
export const AdverseEventDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(AdverseEventDetailView);

export default AdverseEventDetail;



// WEBPACK FOOTER //
// ./src/Components/AdverseEventDetail.jsx